import { render, staticRenderFns } from "./BulkPassChange.vue?vue&type=template&id=cb66e668&scoped=true&"
import script from "./BulkPassChange.vue?vue&type=script&lang=js&"
export * from "./BulkPassChange.vue?vue&type=script&lang=js&"
import style0 from "./BulkPassChange.vue?vue&type=style&index=0&id=cb66e668&prod&lang=css&"
import style1 from "./BulkPassChange.vue?vue&type=style&index=1&id=cb66e668&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb66e668",
  null
  
)

export default component.exports